import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslationService } from '../../../../services/translation.service';
import { AwsAuthService } from '../../../../services/aws-auth.service';

@Component({
  selector: 'app-no-route',
  templateUrl: './no-route.component.html',
  styleUrls: ['./no-route.component.scss']
})
export class NoRouteComponent {
  isUser: any;
  isUserLoggedIn: any;
  mySubscription: any;
  translationData = []
  featureFlags: any;
  isProductionEnv: boolean = true;

  constructor(private readonly router: Router,
    private readonly translationService: TranslationService,
    private readonly _awsAuthService: AwsAuthService) {
    this.featureFlags = this.translationService.featureFlags;
    this.isProductionEnv = this.featureFlags?.general.tempProdFlag;

    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isUser = localStorage.getItem('userLoggedIn');
        this.isUserLoggedIn = this._awsAuthService.getUserLoggedInStatus()
      }
    });
  }

  

}
